import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { BankStorageKindEnum, MoneyTypeEnum } from 'src/enums';
import { MoneyContainer } from 'src/typings';
import { environment } from 'src/environments/environment';
import { normalizeMoneyContainer } from './money-flow.utils';

export interface SearchMoneyContainerDto {
  id?: number;
  description?: string;
  storageKind?: BankStorageKindEnum;
  storageKinds?: BankStorageKindEnum[];
  warehouse_id?: number;
  owner_user_id?: number;
  moneyType?: MoneyTypeEnum;
  isOperational?: boolean;
  limit?: number;
  offset?: number;
  sort_action?: string;
  sort_direction?: string;
}

export interface CreateMoneyContainerDto {
  description: string;
  moneyType: MoneyTypeEnum;
  storageKind: BankStorageKindEnum;
  warehouse_id?: number | null;
  owner_user_id?: number | null;
  isOperational?: boolean;
}

export interface UpdateMoneyContainerDto extends CreateMoneyContainerDto {
  id: number;
  warehouse_id?: number | null;
  owner_user_id?: number | null;
}

@Injectable({
  providedIn: 'root'
})
export class MoneyContainerService {
  constructor(private http: HttpClient) {}

  search(payload: SearchMoneyContainerDto) {
    return this.http
      .post<{ data: MoneyContainer[]; length: number }>(`${environment.BACKEND}/bank/search`, payload)
      .pipe(
        map((response) => ({
          items: (response.data || []).map((item) => normalizeMoneyContainer(item)),
          total: Number(response.length || 0)
        }))
      );
  }

  getOne(id: number) {
    return this.http
      .get<MoneyContainer>(`${environment.BACKEND}/bank/${id}`)
      .pipe(map((doc) => normalizeMoneyContainer(doc)));
  }

  create(payload: CreateMoneyContainerDto) {
    return this.http
      .post<MoneyContainer>(`${environment.BACKEND}/bank/create`, payload)
      .pipe(map((doc) => normalizeMoneyContainer(doc)));
  }

  update(payload: UpdateMoneyContainerDto) {
    return this.http
      .put<MoneyContainer>(`${environment.BACKEND}/bank/update`, payload)
      .pipe(map((doc) => normalizeMoneyContainer(doc)));
  }

  delete(id: number) {
    return this.http.delete(`${environment.BACKEND}/bank/${id}`);
  }
}
